import type { FormEvent } from "react";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import TextBox from "../basic/textBox";
import { LabelPositionEnum, ToggleSlider } from "../basic/toggleSlider";
import { LoginBackground } from "./background";

interface Props {
	username: string;
	setUsername: (value: string) => void;
	password: string;
	setPassword: (value: string) => void;
	rememberMe?: boolean;
	setRememberMe?: (value: boolean) => void;
	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	forgotPassword?: () => void;
	loading: boolean;
	disabled: boolean;
	version?: string;
	error?: string;

	logoImage?: string;
	backgroundImage?: string;
}

export function LoginPage(props: Props) {
	const {
		username,
		setUsername,
		password,
		setPassword,
		rememberMe,
		setRememberMe,
		submitFunction,
		forgotPassword,
		loading,
		disabled,
		version,
		error,
		logoImage,
		backgroundImage,
	} = props;

	return (
		<LoginBackground title="Login" version={version} logoImage={logoImage} backgroundImage={backgroundImage}>
			<form className="tw-grid tw-gap-4" onSubmit={submitFunction}>
				<TextBox
					id="username"
					name="username"
					label="Username"
					value={username}
					changeHandler={setUsername}
					className="!tw-m-0"
					disabled={disabled}
				/>
				<TextBox
					id="password"
					name="password"
					label="Password"
					value={password}
					changeHandler={setPassword}
					type="password"
					className="!tw-m-0"
					disabled={disabled}
				/>
				{rememberMe !== undefined && (
					<ToggleSlider
						id={"rememberMeCheckbox"}
						label={"Remember Username"}
						value={rememberMe}
						changeHandler={setRememberMe}
						labelPosition={LabelPositionEnum.hidden}
						inline
						rounded
						className="!tw-m-0"
					/>
				)}
				{error !== undefined && <span className="tw-text-sm tw-text-red-400">{error}</span>}
				<Loading loading={loading} message="Logging in..." tag="h5">
					<Button type="submit" className="tw-w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Login
					</Button>
				</Loading>
				{forgotPassword && (
					<Button
						type="button"
						className="tw-w-full"
						types={[ButtonTypes.Outline]}
						onClick={forgotPassword}
						disabled={loading}
					>
						Forgot Password
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
